import React, { useState ,useEffect} from "react";
import {
  DialogContent,
  Typography,
  Grid,
  Button,
  TextField,
  Box,
  Paper,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { headers } from "../../utils/utils";

const TagConfig = ({ tags, setTags }) => {
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [newTagLabel, setNewTagLabel] = useState("");

  useEffect(() => {
    console.log("Updated tags:", tags);
  }, [tags]); 

  const handleAddTag = async () => {
    if (newTagLabel.trim()) {
      const newTag = {
        value: newTagLabel,
        groupName: `TicketLabel-${localStorage.getItem("board")}`,
      };

      try {
        const response = await fetch(
          `${process.env.REACT_APP_SYS_CONFIG_MGMT}/systemConfig/save`,
          {
            method: "POST",
            headers: headers(),
            body: JSON.stringify(newTag),
          },
        );

        if (response.ok) {
          const savedTag = await response.json();
          setTags((prevTags) => [...prevTags, savedTag]); // Avoid direct mutation
          setNewTagLabel("");
          setIsInputVisible(false);
        } else {
          console.error("Failed to save the tag:", response.statusText);
        }
      } catch (error) {
        console.error("Error saving the tag:", error);
      }
    }
  };

  const handleDeleteTag = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SYS_CONFIG_MGMT}/systemConfig/update/${id}`,
        {
          method: "PUT",
          headers: headers(),
          body: JSON.stringify({ active: false }),
        },
      );

      if (response.ok) {
        setTags((prevTags) => prevTags.filter((tag) => tag.id !== id));
      } else {
        console.error("Failed to delete tag:", response.statusText);
      }
    } catch (error) {
      console.error("Error while deleting tag:", error);
    }
  };

  return (
    <DialogContent>
      <Typography variant="h5" gutterBottom sx={{ ml: -3 }}>
        Tags
      </Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Grid container spacing={2} justifyContent="center">
          {tags.length > 0 &&
            tags.map((tag) => (
              <Grid item key={tag.id}>
                <Paper
                  elevation={3}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: 1,
                    borderRadius: 4,
                    backgroundColor: "white",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      flexGrow: 1,
                      fontWeight: "medium",
                      color: "#333",
                      px: 1,
                    }}
                  >
                    {tag.value}
                  </Typography>
                  <IconButton
                    onClick={() => handleDeleteTag(tag.id)}
                    aria-label="Delete tag"
                    sx={{
                      color: "#e74c3c",
                      "&:hover": {
                        color: "#c0392b",
                      },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Paper>
              </Grid>
            ))}

          {/* Add New Tag */}
          <Grid item>
            {!isInputVisible ? (
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => setIsInputVisible(true)}
                sx={{ fontWeight: "bold", p: 1.5 }}
              >
                Add Tag
              </Button>
            ) : (
              <>
                <br />
                <TextField
                  variant="standard"
                  size="small"
                  value={newTagLabel}
                  onChange={(e) => setNewTagLabel(e.target.value)}
                  placeholder="Enter new tag"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleAddTag();
                  }}
                  onBlur={() => setIsInputVisible(false)}
                  autoFocus
                  sx={{ width: 200 }}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </DialogContent>
  );
};

export default TagConfig;
